import { render } from "./FooterCom.vue?vue&type=template&id=806a5d70&scoped=true"
const script = {}

import "./FooterCom.vue?vue&type=style&index=0&id=806a5d70&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-806a5d70"]])

export default __exports__